import ConstrainBase from "../ConstrainBase";
import ValidationResult from "../ValidationResult";

/**
 * class StringConstrain
 * Validiert String-Werte analog zur serverseitigen StringConstrain.php
 */
class StringConstrain extends ConstrainBase {

  /**
   * @param {number} min  Mindestlänge (Standard 0)
   * @param {number} max  Maximallänge (Standard unbegrenzt, -1 = kein Limit)
   */
  constructor(min = 0, max = -1) {
    super();
    this.min = min;
    this.max = max;
  }

  validate(value) {
    if (value === null || value === undefined) {
      value = '';
    }
    if (typeof value !== 'string') {
      value = String(value);
    }
    if (this.min > 0 && value.length < this.min) {
      return new ValidationResult(false, `Mindestlänge ist ${this.min} Zeichen.`);
    }
    if (this.max > 0 && value.length > this.max) {
      return new ValidationResult(false, `Maximale Länge ist ${this.max} Zeichen.`);
    }
    return new ValidationResult(true, '');
  }
}

export default StringConstrain;
